// src/store/alternativeSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import secureLocalStorage from 'react-secure-storage';
import { getBooleanValue, getStoredData } from '@/utils/store';
import { AlternativeData } from '@/types/alternative';

interface AlternativesState {
alternatives: AlternativeData[] | []
  alternativesFetched: boolean
  currentAlternative: AlternativeData | null
}

const initialState: AlternativesState = {
    alternatives: getStoredData<AlternativeData[]>('alternatives', []),
    alternativesFetched: getBooleanValue('alternativesFetched'),
    currentAlternative: null
};

const alternativesSlice = createSlice({
  name: 'alternatives',
  initialState,
  reducers: {
    setAlternatives: (state, action: PayloadAction<AlternativesState>) => {
      state.alternatives = action.payload.alternatives;
      state.alternativesFetched = true;

      secureLocalStorage.setItem('alternatives', JSON.stringify(action.payload.alternatives) || '');
      secureLocalStorage.setItem('alternativesFetched', JSON.stringify(true) || '');
    },
    setCurrentAlternative: (state, action: PayloadAction<AlternativeData>) => {
      state.currentAlternative = action.payload;
    },
    clearAlternatives: (state) => {
      state.alternatives = [];
      state.alternativesFetched = false;
      state.currentAlternative = null;

      secureLocalStorage.removeItem('alternatives');
      secureLocalStorage.removeItem('alternativesFetched');
      secureLocalStorage.removeItem('currentAlternative');
    },
  },
});

export const { setAlternatives, clearAlternatives, setCurrentAlternative } = alternativesSlice.actions;
export default alternativesSlice.reducer;